import { defineMessages, IntlShape, useIntl } from "react-intl"

export const convertTokensToCredits = (tokens: number) => {
  // 1 credit = 4000 tokens, min is 1 credit, round up
  return Math.ceil(tokens / 4000)
}

export type SiteConfig = typeof siteConfig
export type SubscriptionPlan = typeof subscriptionPlans
export type SubscriptionPlanKey = keyof typeof subscriptionPlans
export type FeatureFlags = {
  content: boolean
  workspace: boolean
  editor: boolean
  search: boolean
  api: boolean
  tools: boolean
  summary: boolean
  executiveSummary: boolean
  transcriptions: boolean
  images: boolean
  invites: boolean
  seats: boolean
}

// hardcode feature flags for now, move to bd later
export const organizationFeatureFlags: {
  [organizationId: string]: FeatureFlags
} = {
  //dani
  "5a61fbe1-b9ff-4616-8bdf-890877695ade": {
    content: true,
    workspace: true,
    editor: false,
    search: true,
    api: false,
    tools: false,
    summary: true,
    executiveSummary: false,
    transcriptions: true,
    images: true,
    invites: false,
    seats: false,
  },
  // seba
  "f1dad168-6938-4f75-a84f-ed4e099de22d": {
    content: true,
    workspace: true,
    editor: false,
    search: true,
    api: false,
    tools: false,
    summary: true,
    executiveSummary: false,
    transcriptions: true,
    images: true,
    invites: false,
    seats: false,
  },
  // loreto UDD
  "f9a12286-731d-4ed8-b111-41a3e1408483": {
    content: true,
    workspace: true,
    editor: false,
    search: true,
    api: false,
    tools: false,
    summary: true,
    executiveSummary: false,
    transcriptions: true,
    images: true,
    invites: false,
    seats: false,
  },
  "2f8c809f-17c8-41d2-ba7a-72b0b3e00e9e": {
    content: true,
    workspace: true,
    editor: false,
    search: true,
    api: false,
    tools: false,
    summary: true,
    executiveSummary: false,
    transcriptions: true,
    images: true,
    invites: false,
    seats: false,
  },
}

export const subscriptionPlans = {
  FREE: {
    name: "subscriptionPlans.FREE.name",
    description: "subscriptionPlans.FREE.description",
    priceMonthly: 0,
    priceYearly: 0,
    freeMessagesMonthly: 0,
    features: [],
    featureFlags: {
      content: true,
      workspace: true,
      editor: false,
      search: true,
      api: false,
      tools: false,
      summary: true,
      transcriptions: false,
      images: false,
      invites: false,
      seats: false,
    } as FeatureFlags,
    messageLimit: 50,
    costPerMessage: 0.03,
    costPerMessagePastLimit: 0.06,
    href: "#",
  },
  BASIC: {
    name: "subscriptionPlans.BASIC.name",
    description: "subscriptionPlans.BASIC.description",
    priceMonthly: 15000,
    priceYearly: 120000,
    freeMessagesMonthly: 50,
    features: [
      "subscriptionPlans.BASIC.features.0",
      "subscriptionPlans.BASIC.features.1",
      "subscriptionPlans.BASIC.features.2",
      "subscriptionPlans.BASIC.features.3",
    ],
    featureFlags: {
      content: true,
      workspace: true,
      editor: false,
      search: true,
      api: false,
      tools: false,
      summary: true,
      transcriptions: false,
      images: false,
      invites: false,
      seats: false,
    } as FeatureFlags,
    messageLimit: 50,
    costPerMessage: 0.03,
    costPerMessagePastLimit: 0.06,
    href: "#",
  },
  BUSINESS: {
    name: "subscriptionPlans.BUSINESS.name",
    description: "subscriptionPlans.BUSINESS.description",
    priceMonthly: 80000,
    priceYearly: 600000,
    freeMessagesMonthly: 1000,
    features: [
      "subscriptionPlans.BUSINESS.features.0",
      "subscriptionPlans.BUSINESS.features.1",
      "subscriptionPlans.BUSINESS.features.2",
      "subscriptionPlans.BUSINESS.features.3",
      "subscriptionPlans.BUSINESS.features.4",
      "subscriptionPlans.BUSINESS.features.5",
      "subscriptionPlans.BUSINESS.features.6",
      "subscriptionPlans.BUSINESS.features.7",
      "subscriptionPlans.BUSINESS.features.8",
    ],
    featureFlags: {
      content: true,
      workspace: true,
      editor: true,
      search: true,
      api: true,
      tools: false,
      summary: true,
      transcriptions: false,
      images: false,
      invites: true,
      seats: true,
    } as FeatureFlags,
    messageLimit: 1000,
    costPerMessage: 0.02,
    costPerMessagePastLimit: 0.04,
    href: "#",
  },
  PREMIUM: {
    name: "subscriptionPlans.ENTERPRISE.name",
    description: "subscriptionPlans.ENTERPRISE.description",
    priceMonthly: 100,
    priceYearly: 900,
    freeMessagesMonthly: "Unlimited",
    features: [
      "subscriptionPlans.ENTERPRISE.features.0",
      "subscriptionPlans.ENTERPRISE.features.1",
      "subscriptionPlans.ENTERPRISE.features.2",
      "subscriptionPlans.ENTERPRISE.features.3",
      "subscriptionPlans.ENTERPRISE.features.4",
      "subscriptionPlans.ENTERPRISE.features.5",
      "subscriptionPlans.ENTERPRISE.features.6",
      "subscriptionPlans.ENTERPRISE.features.7",
      "subscriptionPlans.ENTERPRISE.features.8",
      "subscriptionPlans.ENTERPRISE.features.9",
    ],
    featureFlags: {
      content: true,
      workspace: true,
      editor: false,
      search: true,
      api: true,
      tools: false,
      summary: true,
      transcriptions: false,
      images: false,
      invites: true,
      seats: true,
    } as FeatureFlags,
    messageLimit: "-",
    costPerMessage: 0,
    costPerMessagePastLimit: 0,
    href: "#",
  },
}

export const siteConfig = {
  name: "42x.ai",
  description:
    "42x.ai is a platform for building and using Assistants. We are building the next generation of AI Assistants that are more intelligent, more capable, and more human.",
  mainNav: [
    {
      title: "Home",
      href: "/workspace",
    },
  ],
  links: {
    twitter: "https://twitter.com/shadcn",
    github: "https://github.com/shadcn/ui",
    docs: "https://ui.shadcn.com",
  },
  subscriptionPlans,
}
